export default __webpack_public_path__ + "static/media/shillongcityTakeover.7b420e5e.png";